// extracted by mini-css-extract-plugin
export var aircallIframe = "_ip-3";
export var fabContainer = "_ip-5";
export var fabRinging = "_ip-6";
export var loadingOverlay = "_ip-4";
export var pulse = "_ip-7";
export var widgetContent = "_ip-2";
export var widgetPanel = "_ip-0";
export var widgetPanelExpanded = "_ip-1";